import {balanceBarView} from '../charts/balanceBarView.js';

// The bar and legend inside a Payables or Receivables card, under its head row:
//   <balance-bar split="aging.payable" scale-max="aging.scaleMax" kind="payables"></balance-bar>
// The card around it is the link to its tab and carries the spoken label (balanceCardLabel), so
// everything here is aria-hidden. It redraws only when the split, the shared scale or its width
// changes.
export default function balanceBar() {
  return {
    restrict: 'E',
    scope: {
      split: '<',
      scaleMax: '<',
      kind: '@'
    },
    template: require('../views/balance-bar.html'),
    link(scope) {
      // `width` is the track, written by chart-width on the template's root.
      scope.$watchGroup(['split', 'scaleMax', 'width', 'kind'], ([split, scaleMax, width, kind]) => {
        scope.vm = balanceBarView(split, scaleMax, width, kind);
      });
    }
  };
}
